'use client';

import { FC } from 'react';

import { isFeatureEnabled } from '@ravago/shared/next-data-access';
import { FeatureToggle } from '@ravago/shared/page-data/models/config';
import { InvoiceForCurrencyForLegalEntity } from '@ravago/shared/page-data/models/elements';
import { RendererGlobals } from '@ravago/shared/page-data/models/utils';

import { useInvoiceStateContext } from '../context/invoice-context';
import { useFetchClosedInvoices } from '../hooks/fetch-closed-invoices.hook';
import { BillingType } from '../models/billing-type.model';
import { Toggle } from '../models/feature-permissions.model';
import { InvoiceProviders } from '../providers/invoice-providers';

import { InvoiceChipList } from './invoice-chip-list/invoice-chip-list';
import { InvoiceOverview } from './invoice-overview/invoice-overview';

type Props = {
   globals: RendererGlobals;
   featureToggles: FeatureToggle[];
   openInvoices: InvoiceForCurrencyForLegalEntity[];
};

export const Invoices: FC<Props> = ({ featureToggles, openInvoices }) => {
   const { selectedBillingType, closedInvoicesQueryParams } = useInvoiceStateContext();

   const isOpenBillingType = selectedBillingType === BillingType.OPEN;
   const isClosedInvoiceFeatureEnabled = isFeatureEnabled(featureToggles, Toggle.CLOSED_INVOICES);

   useFetchClosedInvoices(isClosedInvoiceFeatureEnabled, isOpenBillingType, closedInvoicesQueryParams);

   return (
      <>
         <InvoiceChipList isOpenSelected={isOpenBillingType} hasClosedInvoiceFeatureToggle={isClosedInvoiceFeatureEnabled} />
         <InvoiceOverview openInvoices={openInvoices} showOpenInvoices={isOpenBillingType} featureToggles={featureToggles} />
      </>
   );
};

export const InvoicesWithContext = ({ globals, featureToggles, openInvoices }: Props) => (
   <InvoiceProviders>
      <Invoices globals={globals} featureToggles={featureToggles} openInvoices={openInvoices} />
   </InvoiceProviders>
);
